/* eslint-disable complexity */
import { actionTypes } from '../../constants';
import { fromJS } from 'immutable';

const {
  GET_WEEKLY_BALANCE_ALERT,
  GET_WEEKLY_BALANCE_ALERT_SUCCESS,
  GET_WEEKLY_BALANCE_ALERT_FAILURE,
  UPDATE_WEEKLY_BALANCE_ALERT_SUCCESS,
  UPDATE_WEEKLY_BALANCE_ALERT_FAILURE,
  CLOSE_MODAL,
  SHOW_BUTTON,
  TOGGLE_FLAG,
  DAY_SELECTED,
} = actionTypes;

export const initialState = fromJS({
  WBAAlert: {},
  isError: false,
  toggleFlag: false,
  daySelected: '1',
  fetching: false,
  fetched: false,
  isDisabled: false,
  isFetched: false,
});

const WBAAlert = (state = initialState, action) => {
  switch (action.type) {
    case GET_WEEKLY_BALANCE_ALERT:
      return state.set('getWBAAlert', { fetching: true, fetched: false });

    case GET_WEEKLY_BALANCE_ALERT_SUCCESS:
      return state
        .set('WBAAlert', { WBAAlert: action.payload, fetching: false, fetched: true })
        .set('isFetched', true);

    case GET_WEEKLY_BALANCE_ALERT_FAILURE:
      return state
        .set('WBAAlert', { isError: true, fetching: false, fetched: true })
        .set('isFetched', true);

    case UPDATE_WEEKLY_BALANCE_ALERT_SUCCESS:
      return state.set('WBAAlert', { WBAAlert: action.payload, fetching: false, fetched: false });

    case UPDATE_WEEKLY_BALANCE_ALERT_FAILURE:
      return state.set('isError', {
        isError: true,
        fetching: false,
        fetched: true,
        ...action.meta,
      });

    case CLOSE_MODAL:
      return state.set('isError', { isError: false });

    case SHOW_BUTTON:
      return state.set('isDisabled', action.isDisabled);

    case TOGGLE_FLAG:
      return state.set('toggleFlag', action.toggleFlag);

    case DAY_SELECTED:
      return state.set('daySelected', action.daySelected);

    default:
      return state;
  }
};

export default WBAAlert;
